import { useMemo } from 'react';

import { useTranslation } from 'react-i18next';

interface DeploymentHistoryTranslations {
	title: string;
	columns: {
		timestamp: string;
		change: string;
		type: string;
	};
	loading: string;
	errorTitle: string;
	errorMessage: string;
	pagination: {
		events: string;
	};
}

export const useDeploymentHistoryTranslations = (): DeploymentHistoryTranslations => {
	const { t } = useTranslation();

	return useMemo<DeploymentHistoryTranslations>(
		() => ({
			title: t('DEPLOYMENT_HISTORY.TITLE'),
			columns: {
				timestamp: t('DEPLOYMENT_HISTORY.COLUMNS.TIMESTAMP'),
				change: t('DEPLOYMENT_HISTORY.COLUMNS.CHANGE'),
				type: t('DEPLOYMENT_HISTORY.COLUMNS.TYPE')
			},
			loading: t('DEPLOYMENT_HISTORY.LOADING'),
			errorTitle: t('DEPLOYMENT_HISTORY.ERROR_TITLE'),
			errorMessage: t('DEPLOYMENT_HISTORY.ERROR_MESSAGE'),
			pagination: {
				events: t('DEPLOYMENT_HISTORY.PAGINATION.EVENTS')
			}
		}),
		[t]
	);
};
